import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import DotStatus from 'components/DotStatus/DotStatus'

/**
 * Operator assign card
 * @param {object} props
 * @param {object} props.operator
 * @param {string} props.id
 * @param {function} props.onSelected
 * @param {boolean} [props.isAssigned]
 */
const OperatorAssignCard = (props) => {
  const { user } = useSelector(store => store)
  const { operator, id, isAssigned, onSelected, onDelete, isAction } = props
  const { status, picture, name, lastname, role } = operator

  const onClick = useCallback((type) => {
    onSelected(id, type)
  }, [id, onSelected])

  const renderAction = () => {
    if (onDelete) {
      if (role === 'virtual' && !['owner', 'admin', 'brandManager', 'delegationManager'].includes(user.role)) return null
      return <i className='fa fa-user-times' onClick={() => onClick('remove')} />
    } else {
      return <i className='fa fa-user-plus' onClick={() => onClick('add')} />
    }
  }

  return (
    <div className={`assignation-user py-2 pl-2 ${isAssigned ? 'active' : ''}`}>
      <div className='operator-info'>
        <DotStatus operatorStatus={status} />
        <div
          className='operator-picture'
          alt='Operator Image'
          style={{
            backgroundImage: `url(${picture || 'img/default.png'})`,
          }}
        />
        <div className='operator-name-and-email'>
          <span className='operator-name'>
            {name} {lastname}
          </span>
        </div>
      </div>
      <div className='operator-role'>
        <span>{I18n.t(`roles_${role}`)}</span>
        {isAction ? renderAction() : null}
      </div>
    </div>
  )
}

export default OperatorAssignCard
